import { configureStore, combineReducers, Slice } from '@reduxjs/toolkit';
import {
	ClubMembershipSlice,
	SwipePaymentPlansSlice,
	FetchSwipeTxnSlice,
	FetchSwipeTxnDetailsSlice,
	InitiateSwipePaymentSlice,
	CheckPaymentStatusSlice,
	MerchantInfoSlice,
	FetchSwipeWidgetsSlice,
	FetchDisputedTxnSlice,
	FetchChargebackDetailsSlice,
	UploadChargebackDetailsSlice,
	PendingApplicationSlice,
	ActiveApplicationCountSlice,
	DeviceListSlice,
	ReturnListSlice,
	DeviceReturnStatusSlice,
	FetchOverdueTxnSlice,
	ReleaseChargebackSlice,
	SwipeOldPaymentPlansSlice,
	DeterminePlanFlowSlice,
	FetchPincodeFromMidSlice,
	FetchMigrationStatusSlice,
	ClubMemberInfoSlice,
	MerchantMonthlyLimitSlice,
	DeactivationStatusSlice,
	FetchFaqsFromMerchantSlice,
	FetchAddressListSlice,
	GetMdrChargesSlice,
	SpeakerActiveStatusSlice,
	SpeakerAlertPreferenceSlice,
	IsEligibleForPlanUpgradeSlice,
	ServiceRequestSlice,
	GetLaunchLabsConfigSlice,
	CpvInfoSlice,
} from 'Slices';
import { YearlyCashbackSlice } from 'Slices/YearlyCashbackDetails';
import { ISimpleMap } from 'types';

const reducerMap: ISimpleMap = {
	[ClubMembershipSlice.name]: ClubMembershipSlice.reducer,
	[SwipePaymentPlansSlice.name]: SwipePaymentPlansSlice.reducer,
	[FetchSwipeTxnSlice.name]: FetchSwipeTxnSlice.reducer,
	[FetchSwipeTxnDetailsSlice.name]: FetchSwipeTxnDetailsSlice.reducer,
	[InitiateSwipePaymentSlice.name]: InitiateSwipePaymentSlice.reducer,
	[CheckPaymentStatusSlice.name]: CheckPaymentStatusSlice.reducer,
	[MerchantInfoSlice.name]: MerchantInfoSlice.reducer,
	[FetchSwipeWidgetsSlice.name]: FetchSwipeWidgetsSlice.reducer,
	[FetchDisputedTxnSlice.name]: FetchDisputedTxnSlice.reducer,
	[FetchChargebackDetailsSlice.name]: FetchChargebackDetailsSlice.reducer,
	[UploadChargebackDetailsSlice.name]: UploadChargebackDetailsSlice.reducer,
	[PendingApplicationSlice.name]: PendingApplicationSlice.reducer,
	[ActiveApplicationCountSlice.name]: ActiveApplicationCountSlice.reducer,
	[DeviceListSlice.name]: DeviceListSlice.reducer,
	[ReturnListSlice.name]: ReturnListSlice.reducer,
	[DeviceReturnStatusSlice.name]: DeviceReturnStatusSlice.reducer,
	[FetchOverdueTxnSlice.name]: FetchOverdueTxnSlice.reducer,
	[ReleaseChargebackSlice.name]: ReleaseChargebackSlice.reducer,
	[SwipeOldPaymentPlansSlice.name]: SwipeOldPaymentPlansSlice.reducer,
	[DeterminePlanFlowSlice.name]: DeterminePlanFlowSlice.reducer,
	[FetchPincodeFromMidSlice.name]: FetchPincodeFromMidSlice.reducer,
	[FetchMigrationStatusSlice.name]: FetchMigrationStatusSlice.reducer,
	[ClubMemberInfoSlice.name]: ClubMemberInfoSlice.reducer,
	[MerchantMonthlyLimitSlice.name]: MerchantMonthlyLimitSlice.reducer,
	[DeactivationStatusSlice.name]: DeactivationStatusSlice.reducer,
	[FetchFaqsFromMerchantSlice.name]: FetchFaqsFromMerchantSlice.reducer,
	[FetchAddressListSlice.name]: FetchAddressListSlice.reducer,
	[GetMdrChargesSlice.name]: GetMdrChargesSlice.reducer,
	[YearlyCashbackSlice.name]: YearlyCashbackSlice.reducer,
	[SpeakerActiveStatusSlice.name]: SpeakerActiveStatusSlice.reducer,
	[SpeakerAlertPreferenceSlice.name]: SpeakerAlertPreferenceSlice.reducer,
	[IsEligibleForPlanUpgradeSlice.name]: IsEligibleForPlanUpgradeSlice.reducer,
	[ServiceRequestSlice.name]: ServiceRequestSlice.reducer,
	[GetLaunchLabsConfigSlice.name]: GetLaunchLabsConfigSlice.reducer,
	[CpvInfoSlice.name]: CpvInfoSlice.reducer,
};

const store = configureStore({
	reducer: combineReducers(reducerMap),
});

export const registerSlice = (slice: Slice): void => {
	reducerMap[slice.name] = slice.reducer;
	store.replaceReducer(combineReducers(reducerMap));
};

export default store;
